import React from 'react';

export const ArrowSVG = () => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 62 62"
  >
    <mask
      id="a"
      maskUnits="userSpaceOnUse"
      x="-26.535"
      y="-26.29"
      width="119.501"
      height="119.501"
      fill="#000"
    >
      <path
        fill="#fff"
        d="M-26.535-26.29H92.966V93.211H-26.535z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.423 51.633H1.618v8.214H51.66v.048h8.215V1.646H51.66v43.55L9.346 2.882 3.01 9.22l42.413 42.413z"
      />
    </mask>
    <path
      d="M45.423 51.633l1.061-1.061 2.56 2.56h-3.62v-1.5zm-43.805 0h-1.5v-1.5h1.5v1.5zm0 8.214v1.5h-1.5v-1.5h1.5zm50.042 0v-1.5h1.5v1.5h-1.5zm0 .048v1.5h-1.5v-1.5h1.5zm8.215 0h1.5v1.5h-1.5v-1.5zm0-58.249v-1.5h1.5v1.5h-1.5zm-8.215 0h-1.5v-1.5h1.5v1.5zm0 43.55h1.5v3.622l-2.56-2.561 1.06-1.06zM9.346 2.882l-1.06-1.06L9.346.76l1.061 1.06-1.06 1.061zM3.01 9.22l-1.06 1.06L.887 9.22l1.061-1.06 1.06 1.06zm42.413 43.913H1.618v-3h43.805v3zm-42.305-1.5v8.215h-3v-8.215h3zm-1.5 6.715H51.66v3H1.618v-3zm48.542 1.548v-.048h3v.048h-3zm9.715 1.5H51.66v-3h8.215v3zm1.5-59.749v58.25h-3V1.645h3zM51.66.146h8.215v3H51.66v-3zm-1.5 45.05V1.646h3v43.55h-3zM10.407 1.822l42.314 42.314-2.121 2.121L8.286 3.943l2.121-2.121zM1.95 8.158l6.337-6.336 2.121 2.12L4.07 10.28 1.95 8.158zm42.414 44.535L1.949 10.28 4.07 8.157l42.414 42.414-2.121 2.121z"
      fill="#8A05BE"
      mask="url(#a)"
    />
  </svg>
);
